// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--CKCLE";
export var feedback = "styles-module--feedback--aXffW";
export var title = "styles-module--title--55xxW";
export var buttons = "styles-module--buttons--yMK4h";
export var button = "styles-module--button--bAZR3";